import ComponentLayout from "../../../../src/layouts/component-layout";
import { LabelColors, CardIconColors, CardVariants } from '@primer/react-brand';
import { IconColors } from '@primer/react-brand';
import { PropTableValues } from "../../../../src/components";
import { CopilotIcon, RocketIcon, GitBranchIcon } from '@primer/octicons-react';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import * as React from 'react';
export default {
  ComponentLayout,
  LabelColors,
  CardIconColors,
  CardVariants,
  IconColors,
  PropTableValues,
  CopilotIcon,
  RocketIcon,
  GitBranchIcon,
  InlineCode,
  React
};